import React, { useState } from "react";
import * as Components from "components";
import {
  AddressAutoComplete,
  InputField,
  ProfileImageUploader,
  SearchSelectField,
  VerifyPhoneField,
} from "components/formfields";
import { VerifyPhoneModal } from "components/modals";
import { usaStates } from "content/SearchData";

const SettingProfileForm = ({ values, error, setError }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVerfied, setIsVerfied] = useState(null);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-6">
        <ProfileImageUploader
          name={"profileImage"}
          value={values?.profileImage}
          title="Public Profile"
          description="This is the main profile that will be visible to everyone"
        />
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <div className="w-full md:w-1/2">
            <InputField
              label={"First Name"}
              name={"firstName"}
              placeholder={"Enter First Name"}
              isRequired
            />
          </div>
          <div className="w-full md:w-1/2">
            <InputField
              label={"Last Name"}
              name={"lastName"}
              placeholder={"Enter Last Name"}
              isRequired
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <div className="w-full md:w-1/2">
            <InputField
              label={"Email"}
              name={"email"}
              placeholder={"Enter Email"}
              isRequired
            />
          </div>
          <div className="w-full md:w-1/2">
            <VerifyPhoneField
              label={"Phone"}
              name={"phone"}
              setIsOpen={setIsOpen}
              isRequired
              isVerfied={isVerfied}
              error={error}
            />
          </div>
        </div>
      </div>
      <div className="w-full border-0 border-b dark:border-b-gray-800 pb-6">
        <p className="text-xl  dark:text-white">Personal Address</p>
      </div>
      <div className="flex flex-col gap-6">
        <AddressAutoComplete
          isRequired={true}
          name="streetAddress"
          type="text"
          label="Address"
          placeholder="Enter Address"
          fieldNames={{
            address: "streetAddress",
            city: "city",
            zip: "zip",
            state: "state",
          }}
        />

        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <InputField
            label={"City"}
            name={"city"}
            isRequired
            placeholder={"Enter City"}
          />
          <SearchSelectField
            label={"State"}
            name={"state"}
            options={usaStates}
            placeholder="Select State"
            isRequired={true}
          />

          <InputField
            label={"Zip"}
            name={"zip"}
            type="number"
            placeholder="Enter Zip"
            isRequired={true}
          />
        </div>
      </div>

      <VerifyPhoneModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        setIsVerfied={setIsVerfied}
        setError={setError}
      />
    </div>
  );
};

export default SettingProfileForm;
